import React from 'react';
import clsx from 'clsx';
import ProfileAvatar from '../ProfileAvatar';

/**
 * LoungeAvatar - Neon-Ringed Avatar Component
 * 
 * Features:
 * - Animated neon ring (pink/teal for speaking, purple/pink for highlight)
 * - Glass panel background
 * - Pulsing glow effect
 * - Online status indicator
 */
export function LoungeAvatar({
  profile,
  size = 'md',
  isSpeaking = false,
  isHighlighted = false,
}) {
  const sizeMap = {
    sm: 40,
    md: 56,
    lg: 80,
  };
  
  const px = sizeMap[size];
  
  const ringColor = isSpeaking
    ? 'from-lounge-neonTeal via-lounge-accent to-lounge-neonPink'
    : isHighlighted
    ? 'from-lounge-neonPurple via-lounge-neonPink to-lounge-accent'
    : 'from-slate-600 via-slate-500 to-slate-700';

  return (
    <div className="relative inline-flex items-center justify-center">
      {/* Neon aura ring */}
      <div
        className={clsx(
          'absolute inset-[-3px] rounded-full bg-gradient-to-tr blur-sm opacity-80 transition-all',
          ringColor,
          isSpeaking || isHighlighted ? 'scale-105 animate-pulse-glow' : 'scale-95 opacity-60'
        )}
      />
      {/* Inner glass circle */}
      <div
        className="relative rounded-full bg-lounge-panel border border-lounge-outline shadow-lounge-soft overflow-hidden"
        style={{ width: px, height: px }}
      >
        <ProfileAvatar
          profile={profile}
          size={px}
          className="!rounded-full"
        />
      </div>
      {/* Tiny online dot */}
      <span className="absolute bottom-0 right-0 h-3 w-3 rounded-full bg-lounge-accent shadow-lounge-accent border border-slate-900" />
    </div>
  );
}
